<template>
  <v-container grid-list-xs fluid>
    <v-tabs
      grow
      v-model="tab"
      class="shadow"
      slider-color="primary"
      color=" grey lighten-3"
      active-class="primary white--text"
    >
      <v-tab ripple href="#profile">Profile at a Glance</v-tab>
      <v-tab ripple href="#introduction" disabled
        >Introudction & Projects</v-tab
      >
      <v-tab ripple href="#part1" disabled>{{ $t("part1") }}</v-tab>
      <v-tab ripple href="#part2" disabled>{{ $t("part2") }}</v-tab>
      <v-tab ripple href="#part3" disabled>{{ $t("part3") }}</v-tab>
      <v-tab ripple href="#part4" disabled>{{ $t("part4") }}</v-tab>
      <v-tab ripple href="#part5" disabled>{{ $t("part5") }}</v-tab>
      <v-tab ripple href="#scoreCard" disabled>{{ $t("score_card") }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="shadow">
      <v-tab-item value="profile">
        <profile v-model="CSO" @saved="CSOCreated" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
export default {
  name: "NewCSO",
  components: {
    profile: () => import("./forms/profile")
  },

  data() {
    return {
      tab: "profile",
      disabled: true,
      workingAreas: [],
      CSO: {
        model_id: 1,
        assessment_date: new Date().toISOString().substring(0, 10),
        operational_areas: [],
        summary: {
          items: [
            {
              total_score: 0,
              no_of_standard: 0,
              score_obtained: 0,
              qualifying_score: 0,
              status: "Qualified",
              standard: "Compulsory"
            },
            {
              total_score: 0,
              no_of_standard: 0,
              score_obtained: 0,
              status: "Qualified",
              qualifying_score: 0,
              standard: "Regular"
            },
            {
              total_score: 0,
              standard: "Total",
              no_of_standard: 0,
              score_obtained: 0,
              status: "Qualified",
              qualifying_score: 0
            }
          ],
          decision: "Pending",
          recommendation: "",
          failed_compulsory: 0,
          excellence_award: "NO",
          best_award_sections: "NO",
          pro_rated_regular_sections: [],
          pro_rated_compulsory_sections: [],
          summary: "No Assessment Done Yet"
        }
      }
    };
  },

  methods: {
    CSOCreated() {
      this.$router.push(`/CSOs/edit/${this.CSO.id}`);
    }
  },
  created() {}
};
</script>
